import StyledButton from "components/shared/StyledButton";
import { useCompanySettings } from "hooks/useCompanySettings";
import { useFetchJobsPolling } from "hooks/useJobs";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchAllProcessedEdiFiles } from "store/automatedImportStore";
import { useAppDispatch, useAppSelector } from "store/store";
import { EFetchStatus } from "store/types";

import EdiFilesTable from "./EdiFilesTable";
import { countInterforumEdiJobsInProgress } from "./interforumEdiJobUtils";
import InterforumEdiUploadModal from "./InterforumEdiUploadModal";
import InterforumProcessingBanner from "./InterforumProcessingBanner";
import styles from "./style.module.scss";

const PROCESSING_JOB_POLL_MS = 3_000;

const EDIInterforumSettings = () => {
    const { ediFiles, ediFilesStatus, uploadEdiFileStatus } = useAppSelector((state) => state.automatedImports);
    const jobs = useAppSelector((state) => state.jobs.jobs);
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const { companyInfos } = useCompanySettings();
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

    const processingJobsCount = countInterforumEdiJobsInProgress(jobs);

    const prevProcessingJobsCountRef = useRef(0);
    const isUploading = uploadEdiFileStatus === EFetchStatus.PENDING;
    const hasActiveProcessing = isUploading || processingJobsCount > 0;

    useFetchJobsPolling({ enabled: hasActiveProcessing, intervalMs: PROCESSING_JOB_POLL_MS });

    useEffect(() => {
        if (ediFilesStatus === EFetchStatus.IDLE) {
            dispatch(fetchAllProcessedEdiFiles());
        }
    }, []);

    useEffect(() => {
        if (prevProcessingJobsCountRef.current > 0 && processingJobsCount === 0) {
            dispatch(fetchAllProcessedEdiFiles());
        }

        prevProcessingJobsCountRef.current = processingJobsCount;
    }, [dispatch, processingJobsCount]);

    return (
        <div className={styles["edi-interforum-settings"]}>
            <div className={styles["header"]}>
                <div className={styles["header-text"]}>
                    <h1 className={styles["title"]}>{t("Settings.EDIInterforum.Title")}</h1>
                    <span className={styles["description"]}>{t("Settings.EDIInterforum.Description")}</span>
                </div>
                <StyledButton buttonType="primary" onClick={() => setIsUploadModalOpen(true)}>
                    {t("Settings.EDIInterforum.UploadButton")}
                </StyledButton>
            </div>

            <InterforumProcessingBanner jobs={jobs} isUploading={isUploading} />

            <div className={styles["body"]}>
                <EdiFilesTable ediFiles={ediFiles} ediFilesStatus={ediFilesStatus} />
            </div>

            <InterforumEdiUploadModal
                open={isUploadModalOpen}
                onClose={() => setIsUploadModalOpen(false)}
                companyId={companyInfos?.id}
            />
        </div>
    );
};

export default EDIInterforumSettings;
